<div class="mct-flex mct-col mct-gap-12">
  <div>
    <wl-invoice-selector-form [searchParams]="invoiceSearchParams"></wl-invoice-selector-form>
  </div>
  <div class="mct-flex mct-justify-end mct-items-center">
    <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="searchClicked()">
      <strong [hidden]="!searching"><wl-busy [show]="searching"></wl-busy>&nbsp;{{ 'common.searching' | translate | uppercase }}</strong>
      <strong [hidden]="searching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
    </button>
  </div>
  <div class="atlas-invoice-search-actions mct-flex mct-row">
    <div class="mct-flex mct-row mct-justify-center mct-items-start mct-gap-10">
      <action-button [label]="actionsText" [items]="actionsOptions"> </action-button>
      <div [hidden]="selectedInvoiceCount == 0 && !selectAll">
        {{ 'profiles.search.there-are' | translate | ucfirst }}
        <span style="font-weight: bold">
          &nbsp;{{ selectAll ? searchResult.TotalCount - selectedInvoices.length : selectedInvoices.length }}&nbsp;{{
            'revenue.invoice-selector.tagged-invoices' | translate
          }}&nbsp;
        </span>
        {{ 'revenue.invoice-selector.to-take-action' | translate }}
      </div>
    </div>
    <div class="flex row-collapse no-wrap items-center-center gap-10px">
      <div>
        {{ 'profiles.search.search-returned' | translate | ucfirst }}
        <span style="font-weight: bold"
          >{{ searchResult.TotalCount }}&nbsp;{{ 'revenue.invoice-selector.invoices-label' | translate }}</span
        >
      </div>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-default tall f-wb"
        icon="pi pi-times"
        [label]="'profiles.search.clear' | translate | uppercase"
        (click)="clearSearch()"
      ></button>
    </div>
  </div>
  <div>
    <p-table
      [showGridlines]="true"
      [rows]="invoiceSearchParams.PageSize"
      [value]="searchResult.Result"
      [totalRecords]="searchResult.TotalCount"
      [paginator]="true"
      (onLazyLoad)="lazyLoadSearchResults($event)"
      [lazy]="true"
      [loading]="searching"
    >
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 80px">
            <p-checkbox [(ngModel)]="selectAll" [binary]="true"></p-checkbox>
          </th>
          <th [pSortableColumn]="'InvoiceNum'" style="width: 170px">
            {{ 'revenue.invoice-selector.invoice-num-column-header' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'ProfileReportName'">
            {{ 'revenue.invoice-selector.profile-report-name-column-header' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'RevenueItemName'">
            {{ 'revenue.invoice-selector.revenue-item-column-header' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'DateDue'" class="text-right">
            {{ 'revenue.invoice-selector.date-due-column-header' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'TotalAmount'" class="text-right" style="width: 150px">
            {{ 'revenue.invoice-selector.total-amount-column-header' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'AmountDue'" class="text-right">
            {{ 'revenue.invoice-selector.amount-due-column-header' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'AmountPaid'" class="text-right">
            {{ 'revenue.invoice-selector.amount-paid-column-header' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-invoice>
        <tr>
          <td>
            <p-checkbox [(ngModel)]="invoice.Selected" [binary]="true" (onChange)="invoiceSelectedChanged(invoice)"></p-checkbox>
          </td>
          <td>
            <div style="overflow: hidden">
              <a (click)="navigateToInvoice(invoice.InvoiceNum)">{{ invoice.InvoiceNum }}</a>
            </div>
          </td>
          <td>
            <a [routerLink]="['/profile/' + invoice.ProfileId]">
              <wl-profile-type-icon
                *ngIf="invoice && invoice.ProfileId"
                [isMember]="invoice.ProfileMember"
                [isOrg]="invoice.ProfileOrgInd"
                [profileId]="invoice.ProfileId"
                [memberTypeIconColor]="invoice.ProfileMemberTypeIconColor"
              ></wl-profile-type-icon>
              {{ invoice.ProfileReportName }}
            </a>
          </td>
          <td>
            <div style="overflow: hidden">{{ invoice.RevenueItemName }}</div>
          </td>
          <td class="text-right">
            <div style="overflow: hidden">{{ invoice.DateDue | date }}</div>
          </td>
          <td class="text-right">
            <div style="overflow: hidden">{{ invoice.TotalAmount | currency }}</div>
          </td>
          <td class="text-right">
            <div style="overflow: hidden">{{ invoice.AmountDue | currency }}</div>
          </td>
          <td class="text-right">
            <div style="overflow: hidden">{{ invoice.AmountPaid | currency }}</div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <wl-page-size-dropdown [pageSizes]="[20, 100, 0]" [(pageSize)]="invoiceSearchParams.PageSize" (pageSizeChange)="pageSizeChanged()">
    </wl-page-size-dropdown>
  </div>
</div>
<wl-invoice-finder-write-off #writeOff></wl-invoice-finder-write-off>
<p-dialog
  modal="true"
  header="{{ 'revenue.invoice-selector.actions.generate-payments' | translate | titlecase }}"
  [(visible)]="generatingPayments"
  [closable]="true"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <div class="mct-flex mct-col mct-gap-27">
    <div class="mct-flex mct-row">
      <div class="mct-flex mct-col mct-justify-around mct-items-stretch mct-flex-0-0-50pct">
        <label>{{ 'revenue.invoice-selector.actions.payment-date' | translate | titlecase }}</label>
        <wl-date-selector ngDefaultControl name="paymentDate" [(ngModel)]="payOffDto.PaymentDate" appendTo="body"></wl-date-selector>
      </div>
      <div class="mct-flex mct-col mct-justify-around mct-items-stretch mct-flex-0-0-50pct">
        <label>{{ 'revenue.invoice-selector.actions.apply-date' | translate | titlecase }}</label>
        <wl-date-selector ngDefaultControl name="applyDate" [(ngModel)]="payOffDto.ApplyDate" appendTo="body"></wl-date-selector>
      </div>
    </div>
    <div class="mct-flex mct-col invoice-finder-full">
      <label>{{ 'revenue.invoice-selector.actions.payment-type' | translate | titlecase }}</label>
      <p-select
        optionLabel="PaymentType"
        dataKey="PaymentTypeId"
        placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
        [options]="paymentTypes"
        [style]="{ width: '100%' }"
        [(ngModel)]="selectedPaymentType"
        appendTo="body"
      ></p-select>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch mct-gap-7" style="width: 100%">
      <button pButton type="button" class="btn btn-secondary" (click)="cancelPaymentGenerate()">
        <i class="pi pi-times"></i>
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button pButton type="button" class="btn btn-primary" (click)="generatePayments()" [disabled]="isGenerating">
        <wl-busy [show]="isGenerating"></wl-busy>
        {{ 'revenue.invoice-selector.actions.generate-button' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
<wl-transactions-grid-email-dialog [show]="emailingInvoices" [invoiceSearch]="actionsSearch" (cancelClicked)="emailingInvoices = false">
</wl-transactions-grid-email-dialog>

<p-confirmDialog
  #cd
  key="maxInvoicesAlert"
  header="{{ 'revenue.invoice-selector.actions.max-invoices-header' | translate | titlecase }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="cd.onAccept()">
      {{ 'common.ok' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog
  #selectAnInvoiceDialog
  key="selectAnInvoiceDialog"
  [closable]="true"
  header="{{ 'revenue.invoice-selector.actions.select-an-invoice-header' | translate | titlecase }}"
  [closable]="false"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="selectAnInvoiceDialog.accept()">
      {{ 'common.ok' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog
  #portalPaymentsCd
  key="disablePortalPaymentsConfirmation"
  header="{{ 'revenue.invoice-selector.actions.are-you-sure' | translate | ucfirst }}"
  icon="pi pi-question"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="portalPaymentsCd.accept()">
      {{ 'common.confirm' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="portalPaymentsCd.reject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog
  #rebalanceCd
  key="rebalanceConfirmation"
  header="{{ 'revenue.invoice-selector.actions.are-you-sure' | translate | ucfirst }}"
  icon="pi pi-question"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="rebalanceCd.accept()">
      {{ 'common.confirm' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="rebalanceCd.reject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
